import { ASSIGNABLE_USERS_LIST_QUERY_KEY } from "./const";
import type { AssignToUsersQueryFactory } from "./types";

export const assignToUsersQueryKeys: AssignToUsersQueryFactory = {
    assignableUsersList() {
        return [ASSIGNABLE_USERS_LIST_QUERY_KEY];
    },
};
